import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/images/edit_icon.svg'
import _imports_1 from '@/assets/images/date_range_black.svg'
import _imports_2 from '@/assets/images/chevron_right_black.svg'


const _hoisted_1 = { class: "main-completion-wrapper" }
const _hoisted_2 = { class: "completion-first-block" }
const _hoisted_3 = { class: "top-block" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "edit-icon",
  src: _imports_0
}, null, -1)
const _hoisted_5 = { class: "project-name-block default-text" }
const _hoisted_6 = { class: "task-name-block h5" }
const _hoisted_7 = { class: "bottom-block" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "date-time-text small-text-grey" }, "Date and time", -1)
const _hoisted_9 = { class: "completion-calendar-wrapper" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  class: "calendar-completion-icon",
  src: _imports_1
}, null, -1)
const _hoisted_11 = { class: "time-selector-completion-wrapper" }
const _hoisted_12 = { class: "completion-second-block" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  class: "edit-icon",
  src: _imports_0
}, null, -1)
const _hoisted_14 = { class: "role-and-activity-block" }
const _hoisted_15 = { class: "second-block-title-text small-text-grey" }
const _hoisted_16 = { class: "role-and-action-wrapper" }
const _hoisted_17 = { class: "completion-role-wrapper" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "role-chevron" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1)
const _hoisted_19 = { class: "action-wrapper" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "used-technologies-block" }
const _hoisted_22 = {
  key: 0,
  class: "second-block-title-text small-text-grey"
}
const _hoisted_23 = {
  key: 1,
  class: "completion-no-technologies-text small-text-grey"
}
const _hoisted_24 = { class: "completion-button-wrapper" }
const _hoisted_25 = { class: "created-value-block" }
const _hoisted_26 = {
  key: 0,
  class: "second-block-title-text small-text-grey"
}
const _hoisted_27 = {
  key: 1,
  class: "completion-no-value-text small-text-grey"
}
const _hoisted_28 = { class: "medium-text our-completed-suggestion" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "medium-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tooltip = _resolveComponent("tooltip")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_time_selector = _resolveComponent("time-selector")!
  const _component_ta_button = _resolveComponent("ta-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.editModeActive)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "edit-icon-wrapper",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.editSelectedTask && _ctx.editSelectedTask(...args)))
            }, [
              _createVNode(_component_tooltip, {
                positionFromTop: _ctx.tooltipPositionFromTop,
                text: _ctx.editIconTitleTooltip
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["positionFromTop", "text"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.selected_project_name), 1),
        _createVNode(_component_tooltip, {
          class: "task-name-tooltip",
          positionFromTop: _ctx.tooltipPositionFromTop,
          text: _ctx.task.task_name
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.task.task_name), 1)
          ]),
          _: 1
        }, 8, ["positionFromTop", "text"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_Datepicker, {
            modelValue: _ctx.date,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.date) = $event)),
            autoApply: "",
            onCleared: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clearDate())),
            onClosed: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getDateValue(_ctx.date))),
            monthChangeOnScroll: 'inverse',
            format: _ctx.format,
            closeOnAutoApply: true,
            enableTimePicker: false,
            minDate: _ctx.minmalAllowedValue,
            maxDate: new Date()
          }, null, 8, ["modelValue", "format", "minDate", "maxDate"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_time_selector, {
            hoursStored: _ctx.storedHours,
            minutesStored: _ctx.storedMinutes,
            onCheckSuggestion: _ctx.checkTime
          }, null, 8, ["hoursStored", "minutesStored", "onCheckSuggestion"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", {
        class: "edit-icon-wrapper",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.editTaskTags && _ctx.editTaskTags(...args)))
      }, [
        _createVNode(_component_tooltip, {
          positionFromTop: _ctx.tooltipPositionFromTop,
          text: _ctx.editIconTagsTooltip
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }, 8, ["positionFromTop", "text"])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t("component-completion-view.role-activity")), 1),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", {
              class: _normalizeClass(["completion-role medium-text", _ctx.role])
            }, _toDisplayString(_ctx.buttonText(_ctx.role)), 3),
            _hoisted_18
          ]),
          _createElementVNode("div", _hoisted_19, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actionArray, (actions, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "medium-text",
                key: index
              }, [
                _createTextVNode(_toDisplayString(actions), 1),
                (index + 1 < _ctx.actionArray.length)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, ", "))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        (!_ctx.showNoSelectedTechText)
          ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(_ctx.$t("component-completion-view.used-technology")), 1))
          : _createCommentVNode("", true),
        (_ctx.showNoSelectedTechText)
          ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_ctx.$t("component-completion-view.no-tech-selected")), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_24, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.techSuggestions, (suggestion, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createVNode(_component_ta_button, {
                class: "suggestion-button",
                text: suggestion
              }, null, 8, ["text"])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        (_ctx.customValue || _ctx.taskValue)
          ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(_ctx.$t("component-completion-view.created-value")), 1))
          : _createCommentVNode("", true),
        (!_ctx.customValue && !_ctx.taskValue)
          ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(_ctx.$t("component-completion-view.no-value-selected")), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_28, [
          _createTextVNode(_toDisplayString(_ctx.taskValue) + " ", 1),
          (_ctx.customValue && _ctx.taskValue)
            ? (_openBlock(), _createElementBlock("p", _hoisted_29, ","))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.customValue), 1)
      ])
    ])
  ]))
}